
export default {
  // Reviews
  "edit_review": "Bewertung bearbeiten",
  "review": "Bewertung",
  "film_friendly_score": "Filmfreundlichkeitswert",
  "hand_check": "Handkontrolle",
  "successful": "Erfolgreich",
  "unsuccessful": "Nicht erfolgreich",
  "delete_review": "Bewertung löschen",
  "review_by": "Bewertung von",
};
